import { useEffect, useState } from "react";
import moment from "moment";
import { ConfirmButton } from "../../components/ConfirmButton";
import { notification } from "../../helpers/notification";
import {
    addEventPersonnelPool,
    deleteEventPersonnelPool,
    getEventPersonnelPool,
    updateEventPersonnelPool,
} from "../../services/eventPersonnelServices";

export const PersonnelList = () => {
    const [personnelList, setPersonnelList] = useState([]);
    const [open, setOpen] = useState(false);
    const [editUniqueKey, setEditUniqueKey] = useState("");
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        identityNumber: "",
        oggNumber: "",
        oggExpireDate: "",
        birthDate: "",
        personnelType: "2",
        isRetired: "0",
        iban: "",
        bankName: "",
        gender: "0",
    });

    const onClose = () => {
        setOpen(false);
    };

    const resetForm = () => {
        setFormData({
            name: "",
            surname: "",
            identityNumber: "",
            oggNumber: "",
            oggExpireDate: "",
            birthDate: "",
            personnelType: "2",
            isRetired: "0",
            iban: "",
            bankName: "",
            gender: "0",
        });
        setEditUniqueKey("");
    };

    const saveForm = (e) => {
        e.preventDefault();
        const form = { ...formData };

        if (!form.name || !form.surname || !form.identityNumber) {
            notification.error({ message: "Lütfen zorunlu alanları doldurunuz." });
            return;
        }

        if (form.birthDate) {
            form.birthDate = moment(form.birthDate).format();
        } else {
            form.birthDate = null;
        }

        if (form.oggExpireDate) {
            form.oggExpireDate = moment(form.oggExpireDate).format();
        } else {
            form.oggExpireDate = null;
        }

        form.isRetired = form.isRetired == "1";

        if (editUniqueKey) {
            form.uniqueKey = editUniqueKey;
            updateEventPersonnelPool(form)
                .then(() => {
                    notification.success({ message: "Kayıt başarıyla güncellendi." });
                    resetForm();
                    setOpen(false);
                    getData();
                })
                .catch(() => {
                    notification.error({ message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz" });
                });
        } else {
            addEventPersonnelPool(form)
                .then(() => {
                    notification.success({ message: "Kayıt işlemi başarıyla yapıldı." });
                    resetForm();
                    setOpen(false);
                    getData();
                })
                .catch(() => {
                    notification.error({ message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz" });
                });
        }
    };

    const onDeleteConfirm = (uniqueKey) => {
        deleteEventPersonnelPool(uniqueKey)
            .then(() => {
                notification.success({ message: "Kayıt başarıyla silindi." });
                getData();
            })
            .catch(() => {
                notification.error({ message: "Bir hata oluştu tekrar deneyiniz" });
            });
    };

    const showEditPersonnelItem = (uniqueKey) => {
        if (uniqueKey) {
            const personnel = personnelList.find((f) => f.uniqueKey == uniqueKey);
            setFormData({
                name: personnel.name,
                surname: personnel.surname,
                identityNumber: personnel.identityNumber,
                oggNumber: personnel.oggNumber,
                oggExpireDate: personnel.oggExpireDate ? moment(personnel.oggExpireDate).format("YYYY-MM-DD") : "",
                birthDate: personnel.birthDate ? moment(personnel.birthDate).format("YYYY-MM-DD") : "",
                personnelType: String(personnel.personnelType),
                isRetired: personnel.isRetired ? "1" : "0",
                iban: personnel.iban,
                bankName: personnel.bankName || "",
                gender: "0",
            });
        } else {
            resetForm();
        }
        setEditUniqueKey(uniqueKey);
        setOpen(true);
    };

    const getData = () => {
        getEventPersonnelPool()
            .then((result) => {
                setPersonnelList(result.items);
            })
            .catch(() => {});
    };

    useEffect(() => {
        getData();
    }, []);

    const inputClass = "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none";

    const getPersonnelRoleText = (record) => {
        let role = "Özel Güvenlik";
        if (record.personnelType == 1) role = "Amir";
        else if (record.personnelType == 3) role = "Özel Güvenlik Sorumlusu";
        return role + (record.isRetired ? " (Emekli)" : "");
    };

    return (
        <>
            <div className="max-w-7xl mx-auto px-4 py-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Personel Listesi</h1>
                    <button
                        onClick={() => showEditPersonnelItem("")}
                        className="inline-flex items-center gap-2 px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Personel Ekle
                    </button>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
                    <div className="lg:hidden p-4 space-y-3">
                        {personnelList.length === 0 ? (
                            <div className="text-center py-8 text-gray-500 dark:text-gray-400">Daha önce personel eklenmemiş.</div>
                        ) : (
                            personnelList.map((record) => (
                                <div key={record.uniqueKey} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 border border-gray-200 dark:border-gray-600">
                                    <div className="flex items-start justify-between mb-3">
                                        <div>
                                            <div className="font-semibold text-gray-900 dark:text-white">{record.name} {record.surname}</div>
                                            <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                                {getPersonnelRoleText(record)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                                        <div>
                                            <span className="text-gray-500 dark:text-gray-400 text-xs">TC Kimlik</span>
                                            <div className="text-gray-900 dark:text-gray-100">{record.identityNumber || "-"}</div>
                                        </div>
                                        <div>
                                            <span className="text-gray-500 dark:text-gray-400 text-xs">ÖGG No</span>
                                            <div className="text-gray-900 dark:text-gray-100">{record.oggNumber || "-"}</div>
                                        </div>
                                        <div>
                                            <span className="text-gray-500 dark:text-gray-400 text-xs">ÖGG Bitiş</span>
                                            <div className="text-gray-900 dark:text-gray-100">{record.oggExpireDate ? moment(record.oggExpireDate).format("DD.MM.YYYY") : "-"}</div>
                                        </div>
                                        <div>
                                            <span className="text-gray-500 dark:text-gray-400 text-xs">Telefon</span>
                                            <div className="text-gray-900 dark:text-gray-100">{record.phoneNumber || "-"}</div>
                                        </div>
                                        <div>
                                            <span className="text-gray-500 dark:text-gray-400 text-xs">D.Tarihi</span>
                                            <div className="text-gray-900 dark:text-gray-100">{record.birthDate ? moment(record.birthDate).format("DD.MM.YYYY") : "-"}</div>
                                        </div>
                                        <div>
                                            <span className="text-gray-500 dark:text-gray-400 text-xs">IBAN</span>
                                            <div className="text-gray-900 dark:text-gray-100">{record.iban || "-"}</div>
                                        </div>
                                        <div>
                                            <span className="text-gray-500 dark:text-gray-400 text-xs">Banka</span>
                                            <div className="text-gray-900 dark:text-gray-100">{record.bankName || "-"}</div>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <button
                                            onClick={() => showEditPersonnelItem(record.uniqueKey)}
                                            className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-500 text-white text-xs font-medium rounded-lg hover:bg-blue-600 transition-colors"
                                        >
                                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                            </svg>
                                            Düzenle
                                        </button>
                                        <ConfirmButton onConfirm={() => onDeleteConfirm(record.uniqueKey)} message="Personeli silmek istediğinizden emin misiniz?">
                                            <button
                                                className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-500 text-white text-xs font-medium rounded-lg hover:bg-red-600 transition-colors"
                                            >
                                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                                Sil
                                            </button>
                                        </ConfirmButton>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    <div className="hidden lg:block overflow-x-auto">
                        {personnelList.length === 0 ? (
                            <div className="text-center py-8 text-gray-500 dark:text-gray-400">Daha önce personel eklenmemiş.</div>
                        ) : (
                            <table className="w-full text-sm text-left">
                                <thead className="text-xs text-gray-500 uppercase bg-gray-50 dark:bg-gray-800">
                                    <tr>
                                        <th className="px-4 py-3">Adı</th>
                                        <th className="px-4 py-3">Soyadı</th>
                                        <th className="px-4 py-3">TC Kimlik</th>
                                        <th className="px-4 py-3">ÖGG Numarası</th>
                                        <th className="px-4 py-3">Telefon</th>
                                        <th className="px-4 py-3">D.Tarihi</th>
                                        <th className="px-4 py-3">Görevi</th>
                                        <th className="px-4 py-3">IBAN</th>
                                        <th className="px-4 py-3">Banka</th>
                                        <th className="px-4 py-3 text-right">İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                                    {personnelList.map((record) => (
                                        <tr key={record.uniqueKey} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{record.name}</td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{record.surname}</td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{record.identityNumber}</td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100 whitespace-nowrap">
                                                <div className="inline-flex items-center gap-1.5">
                                                    <span>{record.oggNumber || "-"}</span>
                                                    {record.oggExpireDate && (
                                                        <span
                                                            className="relative group inline-flex items-center cursor-pointer text-blue-500 hover:text-blue-600"
                                                            title={`ÖGG Bitiş Tarihi: ${moment(record.oggExpireDate).format("DD.MM.YYYY")}`}
                                                        >
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                            </svg>
                                                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:flex px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap z-50 pointer-events-none">
                                                                Bitiş: {moment(record.oggExpireDate).format("DD.MM.YYYY")}
                                                            </span>
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{record.phoneNumber}</td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">
                                                {record.birthDate ? moment(record.birthDate).format("DD.MM.YYYY") : "-"}
                                            </td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">
                                                {getPersonnelRoleText(record)}
                                            </td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{record.iban}</td>
                                            <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{record.bankName}</td>
                                            <td className="px-4 py-3 text-right">
                                                <div className="flex items-center justify-end gap-2">
                                                    <button
                                                        onClick={() => showEditPersonnelItem(record.uniqueKey)}
                                                        className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-500 text-white text-xs font-medium rounded-lg hover:bg-blue-600 transition-colors"
                                                    >
                                                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                        Düzenle
                                                    </button>
                                                    <ConfirmButton onConfirm={() => onDeleteConfirm(record.uniqueKey)} message="Personeli silmek istediğinizden emin misiniz?">
                                                        <button
                                                            className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-500 text-white text-xs font-medium rounded-lg hover:bg-red-600 transition-colors"
                                                        >
                                                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                            </svg>
                                                            Sil
                                                        </button>
                                                    </ConfirmButton>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            {open && (
                <>
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]" onClick={onClose} />
                    <div className="fixed right-0 top-0 h-full w-full max-w-lg bg-white dark:bg-gray-900 z-[9999] shadow-2xl transition-transform overflow-auto">
                        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                {editUniqueKey ? "Personel Güncelleme" : "Yeni Personel Oluştur"}
                            </h3>
                            <button onClick={onClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-gray-500">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-6 overflow-y-auto">
                            <form onSubmit={saveForm} className="space-y-5">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Adı</label>
                                        <input
                                            type="text"
                                            required
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            placeholder="Adı"
                                            className={inputClass}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Soyadı</label>
                                        <input
                                            type="text"
                                            required
                                            value={formData.surname}
                                            onChange={(e) => setFormData({ ...formData, surname: e.target.value })}
                                            placeholder="Soyadı"
                                            className={inputClass}
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">TC Kimlik</label>
                                        <input
                                            type="text"
                                            required
                                            value={formData.identityNumber}
                                            onChange={(e) => setFormData({ ...formData, identityNumber: e.target.value })}
                                            placeholder="TC Kimlik"
                                            className={inputClass}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Doğum Günü</label>
                                        <input
                                            type="date"
                                            value={formData.birthDate}
                                            onChange={(e) => setFormData({ ...formData, birthDate: e.target.value })}
                                            className={inputClass}
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">ÖGG Numarası</label>
                                        <input
                                            type="text"
                                            value={formData.oggNumber}
                                            onChange={(e) => setFormData({ ...formData, oggNumber: e.target.value })}
                                            placeholder="ÖGG Numarası"
                                            className={inputClass}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">ÖGG Bitiş Tarihi</label>
                                        <input
                                            type="date"
                                            value={formData.oggExpireDate}
                                            onChange={(e) => setFormData({ ...formData, oggExpireDate: e.target.value })}
                                            className={inputClass}
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Banka Adı</label>
                                        <input
                                            type="text"
                                            value={formData.bankName}
                                            onChange={(e) => setFormData({ ...formData, bankName: e.target.value })}
                                            placeholder="Banka Adı"
                                            className={inputClass}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">IBAN</label>
                                        <input
                                            type="text"
                                            value={formData.iban}
                                            onChange={(e) => setFormData({ ...formData, iban: e.target.value })}
                                            placeholder="IBAN"
                                            className={inputClass}
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Görevi</label>
                                        <select
                                            value={formData.personnelType}
                                            onChange={(e) => setFormData({ ...formData, personnelType: e.target.value })}
                                            className={inputClass}
                                        >
                                            <option value="1">Amir</option>
                                            <option value="2">Güvenlik Görevlisi</option>
                                            <option value="3">Özel Güvenlik Sorumlusu</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Emekli mi?</label>
                                        <select
                                            value={formData.isRetired}
                                            onChange={(e) => setFormData({ ...formData, isRetired: e.target.value })}
                                            className={inputClass}
                                        >
                                            <option value="0">Hayır</option>
                                            <option value="1">Evet</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Cinsiyet</label>
                                        <select
                                            value={formData.gender}
                                            onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                                            className={inputClass}
                                        >
                                            <option value="0">Erkek</option>
                                            <option value="1">Kadın</option>
                                        </select>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="inline-flex items-center gap-2 px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors"
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                                    </svg>
                                    Kaydet
                                </button>
                            </form>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
